export default "__VITE_ASSET__BXIoNa4W__"